import * as React from 'react';

const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 179.1 87.1" {...props}>
    <g data-name="Layer 2">
      <g data-name="Component 15 4">
        <g data-name="Union 12-2">
          <path
            d="M46.3 80.05a36 36 0 0 1-25.63-10.69 36.65 36.65 0 0 1 0-51.63 36.24 36.24 0 0 1 11.52-7.82 36.21 36.21 0 0 1 29.51.58 36.25 36.25 0 0 1 6.57 4 36.62 36.62 0 0 1 5.56 5.29l.45.53h86.27a8.51 8.51 0 0 1 8.5 8.5v29.46a8.51 8.51 0 0 1-8.5 8.5H74.28l-.45.52a36.62 36.62 0 0 1-5.56 5.29 36.25 36.25 0 0 1-6.57 4 35.7 35.7 0 0 1-15.4 3.47Z"
            style={{
              fill: '#44c470'
            }}
          />
          <path
            d="M46.3 78.55a34.13 34.13 0 0 0 14.76-3.31 34.51 34.51 0 0 0 6.3-3.85 35 35 0 0 0 5.33-5.07l.9-1h87a7 7 0 0 0 7-7V28.83a7 7 0 0 0-7-7h-87l-.9-1.06a35.51 35.51 0 0 0-5.33-5.07 35.07 35.07 0 0 0-6.3-3.85 34.69 34.69 0 0 0-28.28-.56 35.12 35.12 0 0 0-11 57A34.54 34.54 0 0 0 46.3 78.55m0 3a38 38 0 0 1 0-76A37.56 37.56 0 0 1 75 18.83h85.58a10 10 0 0 1 10 10v29.44a10 10 0 0 1-10 10H75a37.56 37.56 0 0 1-28.7 13.28Z"
            style={{
              fill: '#f2f2eb'
            }}
          />
        </g>
        <path
          data-name="Icon awesome-edit"
          d="m57.86 28.39 6.34 6.35a.68.68 0 0 1 0 1L48.84 51.06l-6.52.73a1.37 1.37 0 0 1-1.51-1.21.76.76 0 0 1 0-.3l.72-6.53 15.36-15.36a.7.7 0 0 1 .97 0Zm11.39-1.61-3.43-3.43a2.78 2.78 0 0 0-3.89 0l-2.48 2.49a.68.68 0 0 0 0 1l6.34 6.35a.7.7 0 0 0 1 0l2.49-2.49a2.76 2.76 0 0 0-.03-3.92Zm-12.7 20.11V54h-22.5V31.54h16.16a.85.85 0 0 0 .6-.24l2.81-2.81a.85.85 0 0 0 0-1.2.81.81 0 0 0-.6-.24h-20.1a3.37 3.37 0 0 0-3.37 3.37v24.75a3.37 3.37 0 0 0 3.37 3.37h24.75a3.37 3.37 0 0 0 3.38-3.37v-11.1a.85.85 0 0 0-.85-.84.87.87 0 0 0-.59.24l-2.81 2.82a.84.84 0 0 0-.25.6Z"
          style={{
            fill: '#2a2728'
          }}
        />
        <g
          style={{
            isolation: 'isolate'
          }}>
          <text
            transform="translate(74.15 55.55)"
            style={{
              fontSize: 34,
              fontFamily: 'ProximaNova-Bold,Proxima Nova',
              fontWeight: 700,
              letterSpacing: '-.01em',
              isolation: 'isolate',
              fill: '#2a2728'
            }}>
            {'S'}
            <tspan
              x={20.06}
              y={0}
              style={{
                letterSpacing: '-.05em'
              }}>
              {'A'}
            </tspan>
            <tspan
              x={41.72}
              y={0}
              style={{
                letterSpacing: 0
              }}>
              {'VE'}
            </tspan>
          </text>
        </g>
      </g>
    </g>
  </svg>
);

export default SvgComponent;
